// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/SkillModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "daisi.protos.v1";

export interface SkillInfo {
  Id: string;
  AccountId: string;
  Name: string;
  Description: string;
  ShortDescription: string;
  Author: string;
  Version: string;
  IconUrl: string;
  RequiredToolGroups: string[];
  Tags: string[];
  Visibility: string;
  Status: string;
  ReviewedBy: string;
  ReviewedAt?: Date | undefined;
  RejectionReason: string;
  CreatedAt?: Date | undefined;
  UpdatedAt?: Date | undefined;
  DownloadCount: number;
  SystemPromptTemplate: string;
  IsRequired: boolean;
}

export interface SkillReviewInfo {
  Id: string;
  SkillId: string;
  ReviewerEmail: string;
  Status: string;
  Comment: string;
  Timestamp?: Date | undefined;
}

export interface GetSkillsByAccountRequest {
  AccountId: string;
}

export interface GetSkillsByAccountResponse {
  Skills: SkillInfo[];
}

export interface GetSkillByIdRequest {
  Id: string;
}

export interface GetSkillByIdResponse {
  Skill?: SkillInfo | undefined;
}

export interface CreateSkillRequest {
  AccountId: string;
  Name: string;
  Description: string;
  ShortDescription: string;
  Author: string;
  Version: string;
  IconUrl: string;
  RequiredToolGroups: string[];
  Tags: string[];
  Visibility: string;
  SystemPromptTemplate: string;
}

export interface CreateSkillResponse {
  Skill?: SkillInfo | undefined;
}

export interface UpdateSkillRequest {
  Skill?: SkillInfo | undefined;
}

export interface UpdateSkillResponse {
  Skill?: SkillInfo | undefined;
}

export interface GetPendingReviewSkillsRequest {
}

export interface GetPendingReviewSkillsResponse {
  Skills: SkillInfo[];
}

export interface CreateSkillReviewRequest {
  SkillId: string;
  ReviewerEmail: string;
  Status: string;
  Comment: string;
}

export interface CreateSkillReviewResponse {
  Review?: SkillReviewInfo | undefined;
}

export interface GetSkillReviewsRequest {
  SkillId: string;
}

export interface GetSkillReviewsResponse {
  Reviews: SkillReviewInfo[];
}

export interface GetRequiredSkillsRequest {
}

export interface GetRequiredSkillsResponse {
  Skills: SkillInfo[];
}

function createBaseSkillInfo(): SkillInfo {
  return {
    Id: "",
    AccountId: "",
    Name: "",
    Description: "",
    ShortDescription: "",
    Author: "",
    Version: "",
    IconUrl: "",
    RequiredToolGroups: [],
    Tags: [],
    Visibility: "",
    Status: "",
    ReviewedBy: "",
    ReviewedAt: undefined,
    RejectionReason: "",
    CreatedAt: undefined,
    UpdatedAt: undefined,
    DownloadCount: 0,
    SystemPromptTemplate: "",
    IsRequired: false,
  };
}

export const SkillInfo: MessageFns<SkillInfo> = {
  encode(message: SkillInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.Name !== "") {
      writer.uint32(26).string(message.Name);
    }
    if (message.Description !== "") {
      writer.uint32(34).string(message.Description);
    }
    if (message.ShortDescription !== "") {
      writer.uint32(42).string(message.ShortDescription);
    }
    if (message.Author !== "") {
      writer.uint32(50).string(message.Author);
    }
    if (message.Version !== "") {
      writer.uint32(58).string(message.Version);
    }
    if (message.IconUrl !== "") {
      writer.uint32(66).string(message.IconUrl);
    }
    for (const v of message.RequiredToolGroups) {
      writer.uint32(74).string(v!);
    }
    for (const v of message.Tags) {
      writer.uint32(82).string(v!);
    }
    if (message.Visibility !== "") {
      writer.uint32(90).string(message.Visibility);
    }
    if (message.Status !== "") {
      writer.uint32(98).string(message.Status);
    }
    if (message.ReviewedBy !== "") {
      writer.uint32(106).string(message.ReviewedBy);
    }
    if (message.ReviewedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.ReviewedAt), writer.uint32(114).fork()).join();
    }
    if (message.RejectionReason !== "") {
      writer.uint32(122).string(message.RejectionReason);
    }
    if (message.CreatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.CreatedAt), writer.uint32(130).fork()).join();
    }
    if (message.UpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.UpdatedAt), writer.uint32(138).fork()).join();
    }
    if (message.DownloadCount !== 0) {
      writer.uint32(144).int32(message.DownloadCount);
    }
    if (message.SystemPromptTemplate !== "") {
      writer.uint32(154).string(message.SystemPromptTemplate);
    }
    if (message.IsRequired !== false) {
      writer.uint32(160).bool(message.IsRequired);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkillInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkillInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ShortDescription = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Author = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.IconUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.RequiredToolGroups.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.Tags.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.Visibility = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.Status = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.ReviewedBy = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.ReviewedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.RejectionReason = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.CreatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.UpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.DownloadCount = reader.int32();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.SystemPromptTemplate = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.IsRequired = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkillInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
      ShortDescription: isSet(object.ShortDescription) ? globalThis.String(object.ShortDescription) : "",
      Author: isSet(object.Author) ? globalThis.String(object.Author) : "",
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      IconUrl: isSet(object.IconUrl) ? globalThis.String(object.IconUrl) : "",
      RequiredToolGroups: globalThis.Array.isArray(object?.RequiredToolGroups)
        ? object.RequiredToolGroups.map((e: any) => globalThis.String(e))
        : [],
      Tags: globalThis.Array.isArray(object?.Tags) ? object.Tags.map((e: any) => globalThis.String(e)) : [],
      Visibility: isSet(object.Visibility) ? globalThis.String(object.Visibility) : "",
      Status: isSet(object.Status) ? globalThis.String(object.Status) : "",
      ReviewedBy: isSet(object.ReviewedBy) ? globalThis.String(object.ReviewedBy) : "",
      ReviewedAt: isSet(object.ReviewedAt) ? fromJsonTimestamp(object.ReviewedAt) : undefined,
      RejectionReason: isSet(object.RejectionReason) ? globalThis.String(object.RejectionReason) : "",
      CreatedAt: isSet(object.CreatedAt) ? fromJsonTimestamp(object.CreatedAt) : undefined,
      UpdatedAt: isSet(object.UpdatedAt) ? fromJsonTimestamp(object.UpdatedAt) : undefined,
      DownloadCount: isSet(object.DownloadCount) ? globalThis.Number(object.DownloadCount) : 0,
      SystemPromptTemplate: isSet(object.SystemPromptTemplate) ? globalThis.String(object.SystemPromptTemplate) : "",
      IsRequired: isSet(object.IsRequired) ? globalThis.Boolean(object.IsRequired) : false,
    };
  },

  toJSON(message: SkillInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    if (message.ShortDescription !== "") {
      obj.ShortDescription = message.ShortDescription;
    }
    if (message.Author !== "") {
      obj.Author = message.Author;
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.IconUrl !== "") {
      obj.IconUrl = message.IconUrl;
    }
    if (message.RequiredToolGroups?.length) {
      obj.RequiredToolGroups = message.RequiredToolGroups;
    }
    if (message.Tags?.length) {
      obj.Tags = message.Tags;
    }
    if (message.Visibility !== "") {
      obj.Visibility = message.Visibility;
    }
    if (message.Status !== "") {
      obj.Status = message.Status;
    }
    if (message.ReviewedBy !== "") {
      obj.ReviewedBy = message.ReviewedBy;
    }
    if (message.ReviewedAt !== undefined) {
      obj.ReviewedAt = message.ReviewedAt.toISOString();
    }
    if (message.RejectionReason !== "") {
      obj.RejectionReason = message.RejectionReason;
    }
    if (message.CreatedAt !== undefined) {
      obj.CreatedAt = message.CreatedAt.toISOString();
    }
    if (message.UpdatedAt !== undefined) {
      obj.UpdatedAt = message.UpdatedAt.toISOString();
    }
    if (message.DownloadCount !== 0) {
      obj.DownloadCount = Math.round(message.DownloadCount);
    }
    if (message.SystemPromptTemplate !== "") {
      obj.SystemPromptTemplate = message.SystemPromptTemplate;
    }
    if (message.IsRequired !== false) {
      obj.IsRequired = message.IsRequired;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkillInfo>, I>>(base?: I): SkillInfo {
    return SkillInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkillInfo>, I>>(object: I): SkillInfo {
    const message = createBaseSkillInfo();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.Name = object.Name ?? "";
    message.Description = object.Description ?? "";
    message.ShortDescription = object.ShortDescription ?? "";
    message.Author = object.Author ?? "";
    message.Version = object.Version ?? "";
    message.IconUrl = object.IconUrl ?? "";
    message.RequiredToolGroups = object.RequiredToolGroups?.map((e) => e) || [];
    message.Tags = object.Tags?.map((e) => e) || [];
    message.Visibility = object.Visibility ?? "";
    message.Status = object.Status ?? "";
    message.ReviewedBy = object.ReviewedBy ?? "";
    message.ReviewedAt = object.ReviewedAt ?? undefined;
    message.RejectionReason = object.RejectionReason ?? "";
    message.CreatedAt = object.CreatedAt ?? undefined;
    message.UpdatedAt = object.UpdatedAt ?? undefined;
    message.DownloadCount = object.DownloadCount ?? 0;
    message.SystemPromptTemplate = object.SystemPromptTemplate ?? "";
    message.IsRequired = object.IsRequired ?? false;
    return message;
  },
};

function createBaseSkillReviewInfo(): SkillReviewInfo {
  return { Id: "", SkillId: "", ReviewerEmail: "", Status: "", Comment: "", Timestamp: undefined };
}

export const SkillReviewInfo: MessageFns<SkillReviewInfo> = {
  encode(message: SkillReviewInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.SkillId !== "") {
      writer.uint32(18).string(message.SkillId);
    }
    if (message.ReviewerEmail !== "") {
      writer.uint32(26).string(message.ReviewerEmail);
    }
    if (message.Status !== "") {
      writer.uint32(34).string(message.Status);
    }
    if (message.Comment !== "") {
      writer.uint32(42).string(message.Comment);
    }
    if (message.Timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.Timestamp), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkillReviewInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkillReviewInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.SkillId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ReviewerEmail = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Status = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Comment = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkillReviewInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      SkillId: isSet(object.SkillId) ? globalThis.String(object.SkillId) : "",
      ReviewerEmail: isSet(object.ReviewerEmail) ? globalThis.String(object.ReviewerEmail) : "",
      Status: isSet(object.Status) ? globalThis.String(object.Status) : "",
      Comment: isSet(object.Comment) ? globalThis.String(object.Comment) : "",
      Timestamp: isSet(object.Timestamp) ? fromJsonTimestamp(object.Timestamp) : undefined,
    };
  },

  toJSON(message: SkillReviewInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.SkillId !== "") {
      obj.SkillId = message.SkillId;
    }
    if (message.ReviewerEmail !== "") {
      obj.ReviewerEmail = message.ReviewerEmail;
    }
    if (message.Status !== "") {
      obj.Status = message.Status;
    }
    if (message.Comment !== "") {
      obj.Comment = message.Comment;
    }
    if (message.Timestamp !== undefined) {
      obj.Timestamp = message.Timestamp.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkillReviewInfo>, I>>(base?: I): SkillReviewInfo {
    return SkillReviewInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkillReviewInfo>, I>>(object: I): SkillReviewInfo {
    const message = createBaseSkillReviewInfo();
    message.Id = object.Id ?? "";
    message.SkillId = object.SkillId ?? "";
    message.ReviewerEmail = object.ReviewerEmail ?? "";
    message.Status = object.Status ?? "";
    message.Comment = object.Comment ?? "";
    message.Timestamp = object.Timestamp ?? undefined;
    return message;
  },
};

function createBaseGetSkillsByAccountRequest(): GetSkillsByAccountRequest {
  return { AccountId: "" };
}

export const GetSkillsByAccountRequest: MessageFns<GetSkillsByAccountRequest> = {
  encode(message: GetSkillsByAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSkillsByAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSkillsByAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSkillsByAccountRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: GetSkillsByAccountRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSkillsByAccountRequest>, I>>(base?: I): GetSkillsByAccountRequest {
    return GetSkillsByAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSkillsByAccountRequest>, I>>(object: I): GetSkillsByAccountRequest {
    const message = createBaseGetSkillsByAccountRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseGetSkillsByAccountResponse(): GetSkillsByAccountResponse {
  return { Skills: [] };
}

export const GetSkillsByAccountResponse: MessageFns<GetSkillsByAccountResponse> = {
  encode(message: GetSkillsByAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Skills) {
      SkillInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSkillsByAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSkillsByAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skills.push(SkillInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSkillsByAccountResponse {
    return {
      Skills: globalThis.Array.isArray(object?.Skills) ? object.Skills.map((e: any) => SkillInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetSkillsByAccountResponse): unknown {
    const obj: any = {};
    if (message.Skills?.length) {
      obj.Skills = message.Skills.map((e) => SkillInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSkillsByAccountResponse>, I>>(base?: I): GetSkillsByAccountResponse {
    return GetSkillsByAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSkillsByAccountResponse>, I>>(object: I): GetSkillsByAccountResponse {
    const message = createBaseGetSkillsByAccountResponse();
    message.Skills = object.Skills?.map((e) => SkillInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSkillByIdRequest(): GetSkillByIdRequest {
  return { Id: "" };
}

export const GetSkillByIdRequest: MessageFns<GetSkillByIdRequest> = {
  encode(message: GetSkillByIdRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSkillByIdRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSkillByIdRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSkillByIdRequest {
    return { Id: isSet(object.Id) ? globalThis.String(object.Id) : "" };
  },

  toJSON(message: GetSkillByIdRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSkillByIdRequest>, I>>(base?: I): GetSkillByIdRequest {
    return GetSkillByIdRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSkillByIdRequest>, I>>(object: I): GetSkillByIdRequest {
    const message = createBaseGetSkillByIdRequest();
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseGetSkillByIdResponse(): GetSkillByIdResponse {
  return { Skill: undefined };
}

export const GetSkillByIdResponse: MessageFns<GetSkillByIdResponse> = {
  encode(message: GetSkillByIdResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Skill !== undefined) {
      SkillInfo.encode(message.Skill, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSkillByIdResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSkillByIdResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skill = SkillInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSkillByIdResponse {
    return { Skill: isSet(object.Skill) ? SkillInfo.fromJSON(object.Skill) : undefined };
  },

  toJSON(message: GetSkillByIdResponse): unknown {
    const obj: any = {};
    if (message.Skill !== undefined) {
      obj.Skill = SkillInfo.toJSON(message.Skill);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSkillByIdResponse>, I>>(base?: I): GetSkillByIdResponse {
    return GetSkillByIdResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSkillByIdResponse>, I>>(object: I): GetSkillByIdResponse {
    const message = createBaseGetSkillByIdResponse();
    message.Skill = (object.Skill !== undefined && object.Skill !== null)
      ? SkillInfo.fromPartial(object.Skill)
      : undefined;
    return message;
  },
};

function createBaseCreateSkillRequest(): CreateSkillRequest {
  return {
    AccountId: "",
    Name: "",
    Description: "",
    ShortDescription: "",
    Author: "",
    Version: "",
    IconUrl: "",
    RequiredToolGroups: [],
    Tags: [],
    Visibility: "",
    SystemPromptTemplate: "",
  };
}

export const CreateSkillRequest: MessageFns<CreateSkillRequest> = {
  encode(message: CreateSkillRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.Description !== "") {
      writer.uint32(26).string(message.Description);
    }
    if (message.ShortDescription !== "") {
      writer.uint32(34).string(message.ShortDescription);
    }
    if (message.Author !== "") {
      writer.uint32(42).string(message.Author);
    }
    if (message.Version !== "") {
      writer.uint32(50).string(message.Version);
    }
    if (message.IconUrl !== "") {
      writer.uint32(58).string(message.IconUrl);
    }
    for (const v of message.RequiredToolGroups) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.Tags) {
      writer.uint32(74).string(v!);
    }
    if (message.Visibility !== "") {
      writer.uint32(82).string(message.Visibility);
    }
    if (message.SystemPromptTemplate !== "") {
      writer.uint32(90).string(message.SystemPromptTemplate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSkillRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSkillRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ShortDescription = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Author = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.IconUrl = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.RequiredToolGroups.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.Tags.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.Visibility = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.SystemPromptTemplate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSkillRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
      ShortDescription: isSet(object.ShortDescription) ? globalThis.String(object.ShortDescription) : "",
      Author: isSet(object.Author) ? globalThis.String(object.Author) : "",
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      IconUrl: isSet(object.IconUrl) ? globalThis.String(object.IconUrl) : "",
      RequiredToolGroups: globalThis.Array.isArray(object?.RequiredToolGroups)
        ? object.RequiredToolGroups.map((e: any) => globalThis.String(e))
        : [],
      Tags: globalThis.Array.isArray(object?.Tags) ? object.Tags.map((e: any) => globalThis.String(e)) : [],
      Visibility: isSet(object.Visibility) ? globalThis.String(object.Visibility) : "",
      SystemPromptTemplate: isSet(object.SystemPromptTemplate) ? globalThis.String(object.SystemPromptTemplate) : "",
    };
  },

  toJSON(message: CreateSkillRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    if (message.ShortDescription !== "") {
      obj.ShortDescription = message.ShortDescription;
    }
    if (message.Author !== "") {
      obj.Author = message.Author;
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.IconUrl !== "") {
      obj.IconUrl = message.IconUrl;
    }
    if (message.RequiredToolGroups?.length) {
      obj.RequiredToolGroups = message.RequiredToolGroups;
    }
    if (message.Tags?.length) {
      obj.Tags = message.Tags;
    }
    if (message.Visibility !== "") {
      obj.Visibility = message.Visibility;
    }
    if (message.SystemPromptTemplate !== "") {
      obj.SystemPromptTemplate = message.SystemPromptTemplate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSkillRequest>, I>>(base?: I): CreateSkillRequest {
    return CreateSkillRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSkillRequest>, I>>(object: I): CreateSkillRequest {
    const message = createBaseCreateSkillRequest();
    message.AccountId = object.AccountId ?? "";
    message.Name = object.Name ?? "";
    message.Description = object.Description ?? "";
    message.ShortDescription = object.ShortDescription ?? "";
    message.Author = object.Author ?? "";
    message.Version = object.Version ?? "";
    message.IconUrl = object.IconUrl ?? "";
    message.RequiredToolGroups = object.RequiredToolGroups?.map((e) => e) || [];
    message.Tags = object.Tags?.map((e) => e) || [];
    message.Visibility = object.Visibility ?? "";
    message.SystemPromptTemplate = object.SystemPromptTemplate ?? "";
    return message;
  },
};

function createBaseCreateSkillResponse(): CreateSkillResponse {
  return { Skill: undefined };
}

export const CreateSkillResponse: MessageFns<CreateSkillResponse> = {
  encode(message: CreateSkillResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Skill !== undefined) {
      SkillInfo.encode(message.Skill, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSkillResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSkillResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skill = SkillInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSkillResponse {
    return { Skill: isSet(object.Skill) ? SkillInfo.fromJSON(object.Skill) : undefined };
  },

  toJSON(message: CreateSkillResponse): unknown {
    const obj: any = {};
    if (message.Skill !== undefined) {
      obj.Skill = SkillInfo.toJSON(message.Skill);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSkillResponse>, I>>(base?: I): CreateSkillResponse {
    return CreateSkillResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSkillResponse>, I>>(object: I): CreateSkillResponse {
    const message = createBaseCreateSkillResponse();
    message.Skill = (object.Skill !== undefined && object.Skill !== null)
      ? SkillInfo.fromPartial(object.Skill)
      : undefined;
    return message;
  },
};

function createBaseUpdateSkillRequest(): UpdateSkillRequest {
  return { Skill: undefined };
}

export const UpdateSkillRequest: MessageFns<UpdateSkillRequest> = {
  encode(message: UpdateSkillRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Skill !== undefined) {
      SkillInfo.encode(message.Skill, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSkillRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSkillRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skill = SkillInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSkillRequest {
    return { Skill: isSet(object.Skill) ? SkillInfo.fromJSON(object.Skill) : undefined };
  },

  toJSON(message: UpdateSkillRequest): unknown {
    const obj: any = {};
    if (message.Skill !== undefined) {
      obj.Skill = SkillInfo.toJSON(message.Skill);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSkillRequest>, I>>(base?: I): UpdateSkillRequest {
    return UpdateSkillRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSkillRequest>, I>>(object: I): UpdateSkillRequest {
    const message = createBaseUpdateSkillRequest();
    message.Skill = (object.Skill !== undefined && object.Skill !== null)
      ? SkillInfo.fromPartial(object.Skill)
      : undefined;
    return message;
  },
};

function createBaseUpdateSkillResponse(): UpdateSkillResponse {
  return { Skill: undefined };
}

export const UpdateSkillResponse: MessageFns<UpdateSkillResponse> = {
  encode(message: UpdateSkillResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Skill !== undefined) {
      SkillInfo.encode(message.Skill, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSkillResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSkillResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skill = SkillInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSkillResponse {
    return { Skill: isSet(object.Skill) ? SkillInfo.fromJSON(object.Skill) : undefined };
  },

  toJSON(message: UpdateSkillResponse): unknown {
    const obj: any = {};
    if (message.Skill !== undefined) {
      obj.Skill = SkillInfo.toJSON(message.Skill);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSkillResponse>, I>>(base?: I): UpdateSkillResponse {
    return UpdateSkillResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSkillResponse>, I>>(object: I): UpdateSkillResponse {
    const message = createBaseUpdateSkillResponse();
    message.Skill = (object.Skill !== undefined && object.Skill !== null)
      ? SkillInfo.fromPartial(object.Skill)
      : undefined;
    return message;
  },
};

function createBaseGetPendingReviewSkillsRequest(): GetPendingReviewSkillsRequest {
  return {};
}

export const GetPendingReviewSkillsRequest: MessageFns<GetPendingReviewSkillsRequest> = {
  encode(_: GetPendingReviewSkillsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPendingReviewSkillsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPendingReviewSkillsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetPendingReviewSkillsRequest {
    return {};
  },

  toJSON(_: GetPendingReviewSkillsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPendingReviewSkillsRequest>, I>>(base?: I): GetPendingReviewSkillsRequest {
    return GetPendingReviewSkillsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPendingReviewSkillsRequest>, I>>(_: I): GetPendingReviewSkillsRequest {
    const message = createBaseGetPendingReviewSkillsRequest();
    return message;
  },
};

function createBaseGetPendingReviewSkillsResponse(): GetPendingReviewSkillsResponse {
  return { Skills: [] };
}

export const GetPendingReviewSkillsResponse: MessageFns<GetPendingReviewSkillsResponse> = {
  encode(message: GetPendingReviewSkillsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Skills) {
      SkillInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPendingReviewSkillsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPendingReviewSkillsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skills.push(SkillInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPendingReviewSkillsResponse {
    return {
      Skills: globalThis.Array.isArray(object?.Skills) ? object.Skills.map((e: any) => SkillInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetPendingReviewSkillsResponse): unknown {
    const obj: any = {};
    if (message.Skills?.length) {
      obj.Skills = message.Skills.map((e) => SkillInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPendingReviewSkillsResponse>, I>>(base?: I): GetPendingReviewSkillsResponse {
    return GetPendingReviewSkillsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPendingReviewSkillsResponse>, I>>(
    object: I,
  ): GetPendingReviewSkillsResponse {
    const message = createBaseGetPendingReviewSkillsResponse();
    message.Skills = object.Skills?.map((e) => SkillInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateSkillReviewRequest(): CreateSkillReviewRequest {
  return { SkillId: "", ReviewerEmail: "", Status: "", Comment: "" };
}

export const CreateSkillReviewRequest: MessageFns<CreateSkillReviewRequest> = {
  encode(message: CreateSkillReviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SkillId !== "") {
      writer.uint32(10).string(message.SkillId);
    }
    if (message.ReviewerEmail !== "") {
      writer.uint32(18).string(message.ReviewerEmail);
    }
    if (message.Status !== "") {
      writer.uint32(26).string(message.Status);
    }
    if (message.Comment !== "") {
      writer.uint32(34).string(message.Comment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSkillReviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSkillReviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SkillId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ReviewerEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Status = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Comment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSkillReviewRequest {
    return {
      SkillId: isSet(object.SkillId) ? globalThis.String(object.SkillId) : "",
      ReviewerEmail: isSet(object.ReviewerEmail) ? globalThis.String(object.ReviewerEmail) : "",
      Status: isSet(object.Status) ? globalThis.String(object.Status) : "",
      Comment: isSet(object.Comment) ? globalThis.String(object.Comment) : "",
    };
  },

  toJSON(message: CreateSkillReviewRequest): unknown {
    const obj: any = {};
    if (message.SkillId !== "") {
      obj.SkillId = message.SkillId;
    }
    if (message.ReviewerEmail !== "") {
      obj.ReviewerEmail = message.ReviewerEmail;
    }
    if (message.Status !== "") {
      obj.Status = message.Status;
    }
    if (message.Comment !== "") {
      obj.Comment = message.Comment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSkillReviewRequest>, I>>(base?: I): CreateSkillReviewRequest {
    return CreateSkillReviewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSkillReviewRequest>, I>>(object: I): CreateSkillReviewRequest {
    const message = createBaseCreateSkillReviewRequest();
    message.SkillId = object.SkillId ?? "";
    message.ReviewerEmail = object.ReviewerEmail ?? "";
    message.Status = object.Status ?? "";
    message.Comment = object.Comment ?? "";
    return message;
  },
};

function createBaseCreateSkillReviewResponse(): CreateSkillReviewResponse {
  return { Review: undefined };
}

export const CreateSkillReviewResponse: MessageFns<CreateSkillReviewResponse> = {
  encode(message: CreateSkillReviewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Review !== undefined) {
      SkillReviewInfo.encode(message.Review, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSkillReviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSkillReviewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Review = SkillReviewInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSkillReviewResponse {
    return { Review: isSet(object.Review) ? SkillReviewInfo.fromJSON(object.Review) : undefined };
  },

  toJSON(message: CreateSkillReviewResponse): unknown {
    const obj: any = {};
    if (message.Review !== undefined) {
      obj.Review = SkillReviewInfo.toJSON(message.Review);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateSkillReviewResponse>, I>>(base?: I): CreateSkillReviewResponse {
    return CreateSkillReviewResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateSkillReviewResponse>, I>>(object: I): CreateSkillReviewResponse {
    const message = createBaseCreateSkillReviewResponse();
    message.Review = (object.Review !== undefined && object.Review !== null)
      ? SkillReviewInfo.fromPartial(object.Review)
      : undefined;
    return message;
  },
};

function createBaseGetSkillReviewsRequest(): GetSkillReviewsRequest {
  return { SkillId: "" };
}

export const GetSkillReviewsRequest: MessageFns<GetSkillReviewsRequest> = {
  encode(message: GetSkillReviewsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SkillId !== "") {
      writer.uint32(10).string(message.SkillId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSkillReviewsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSkillReviewsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SkillId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSkillReviewsRequest {
    return { SkillId: isSet(object.SkillId) ? globalThis.String(object.SkillId) : "" };
  },

  toJSON(message: GetSkillReviewsRequest): unknown {
    const obj: any = {};
    if (message.SkillId !== "") {
      obj.SkillId = message.SkillId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSkillReviewsRequest>, I>>(base?: I): GetSkillReviewsRequest {
    return GetSkillReviewsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSkillReviewsRequest>, I>>(object: I): GetSkillReviewsRequest {
    const message = createBaseGetSkillReviewsRequest();
    message.SkillId = object.SkillId ?? "";
    return message;
  },
};

function createBaseGetSkillReviewsResponse(): GetSkillReviewsResponse {
  return { Reviews: [] };
}

export const GetSkillReviewsResponse: MessageFns<GetSkillReviewsResponse> = {
  encode(message: GetSkillReviewsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Reviews) {
      SkillReviewInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSkillReviewsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSkillReviewsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Reviews.push(SkillReviewInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSkillReviewsResponse {
    return {
      Reviews: globalThis.Array.isArray(object?.Reviews)
        ? object.Reviews.map((e: any) => SkillReviewInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetSkillReviewsResponse): unknown {
    const obj: any = {};
    if (message.Reviews?.length) {
      obj.Reviews = message.Reviews.map((e) => SkillReviewInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSkillReviewsResponse>, I>>(base?: I): GetSkillReviewsResponse {
    return GetSkillReviewsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSkillReviewsResponse>, I>>(object: I): GetSkillReviewsResponse {
    const message = createBaseGetSkillReviewsResponse();
    message.Reviews = object.Reviews?.map((e) => SkillReviewInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetRequiredSkillsRequest(): GetRequiredSkillsRequest {
  return {};
}

export const GetRequiredSkillsRequest: MessageFns<GetRequiredSkillsRequest> = {
  encode(_: GetRequiredSkillsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRequiredSkillsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRequiredSkillsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetRequiredSkillsRequest {
    return {};
  },

  toJSON(_: GetRequiredSkillsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRequiredSkillsRequest>, I>>(base?: I): GetRequiredSkillsRequest {
    return GetRequiredSkillsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRequiredSkillsRequest>, I>>(_: I): GetRequiredSkillsRequest {
    const message = createBaseGetRequiredSkillsRequest();
    return message;
  },
};

function createBaseGetRequiredSkillsResponse(): GetRequiredSkillsResponse {
  return { Skills: [] };
}

export const GetRequiredSkillsResponse: MessageFns<GetRequiredSkillsResponse> = {
  encode(message: GetRequiredSkillsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Skills) {
      SkillInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRequiredSkillsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRequiredSkillsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Skills.push(SkillInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRequiredSkillsResponse {
    return {
      Skills: globalThis.Array.isArray(object?.Skills) ? object.Skills.map((e: any) => SkillInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetRequiredSkillsResponse): unknown {
    const obj: any = {};
    if (message.Skills?.length) {
      obj.Skills = message.Skills.map((e) => SkillInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRequiredSkillsResponse>, I>>(base?: I): GetRequiredSkillsResponse {
    return GetRequiredSkillsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRequiredSkillsResponse>, I>>(object: I): GetRequiredSkillsResponse {
    const message = createBaseGetRequiredSkillsResponse();
    message.Skills = object.Skills?.map((e) => SkillInfo.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
